import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const HeaderWrapper = styled.div`
  display: flex;
  height: 64px;
  background: ${COLORS.cirrus_white};
  padding: 0px 16px 0px 16px;
  justify-content: center;
  align-items: center;
  border-top: 1px solid ${COLORS.footer_border};

  .label {
    line-height: 22.4px;
  }
`;
